import React, { Component } 	from 'react'
import { connect } 				from 'react-redux'
import { currenciesAction } 	from '../../actions/contentActions'
import { post } 				from '../../services/apiServices'
import { token } 				from '../../services/authServices'
import ReactPaginate 			from 'react-paginate'
import { withStyles } 			from 'material-ui/styles'
import Icon 					from 'material-ui/Icon'
import { CircularProgress } 	from 'material-ui/Progress'
import Select 					from 'material-ui/Select'
import { MenuItem } 			from 'material-ui/Menu'
import Input, { InputLabel } 	from 'material-ui/Input'
import { FormControl,
	FormHelperText } 			from 'material-ui/Form'
import TextField 				from 'material-ui/TextField'
import Switch 					from 'material-ui/Switch'
import Button 					from 'material-ui/Button'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow } 					from 'material-ui/Table'

const styles = {
	progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    },
	formWrap: {
		display: 'flex',
		alignItems: 'center'
	},
	formControl: {
		minWidth: '150px'
	},
	textField: {
		maxWidth: '100px',
		marginLeft: '40px'
	},
	button: {
		marginLeft: '40px'
	}
}

class Currency extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'data' : null,
			'currency' : ''
		}
	}

	getDefaultCurrency = () => {
		let currencies = this.props.currencies.available_currencies
		let defaultCurrency = currencies.filter(currency =>
			currency.is_default === true
		)

		this.setState({'currency' : defaultCurrency[0].id})
	}

	onSubmit = () => {
		let state = this.state

		post('/admin/settings/currency', {
			'family_price' : state.data.family_price,
			'school_price' : state.data.school_price,
			'default_currency_id' : state.currency
		}, token).then(res => {
		})
	}

	hadleCurrencyChange = e => {
		let newState = this.state;

		newState[e.target.name] = e.target.value;
		this.setState(newState)
	}

	handleStatusChange = id => event => {
		let statuses = this.state.data.statuses
		let newStatus = event.target.checked ?
			statuses.on : statuses.off

		post('/admin/settings/currency', {
			'currency_id' : id,
			'status' : newStatus
		}, token).then(res => {
			let response = res.data
			let currencies = this.state.data.currencies.resource.data
			let availableCurrencies = this.state.data.available_currencies
			let newData = this.state.data

			if (response.success) {
				currencies.filter(currency => {
					if(currency.id == id) {
						currency.status = newStatus == "enabled" ? "on" : "off"
					}
				})

				newData.currencies.resource.data = currencies
				newData.available_currencies = response.available_currencies
			}

			this.setState({data: newData})
		})
	}

	handleDataChange = e => {
		let newState = this.state.data;

		newState[e.target.name] = e.target.value;
		this.setState(newState)
	}

	handlePageChange = action => {
		this.props.pageChange(action.selected + 1).then(res => {
			this.setState({'data' : this.props.currencies})
		})
	}

	renderCurrenciesSelectList = () => {
		let currencies = this.state.data.available_currencies
		let result = []

		currencies.map(currency => {
			result.push(
				<MenuItem
					key={currency.id}
					value={currency.id}>
					{currency.code}
				</MenuItem>
			)
		})

		return result.map(item => item)
	}

	renderCurrenciesList = () => {
		let currencies = this.state.data.currencies.resource.data
		let result = []

		currencies.map(currency => {
			let status = currency.status == 'on' ? true : false
			result.push(
				<TableRow key={currency.id}>
					<TableCell padding="none">
						{currency.code}
					</TableCell>
					<TableCell padding="none">
						{currency.value}
					</TableCell>
					<TableCell padding="none">
						<Switch
							color="primary"
							checked={status}
							onChange={this.handleStatusChange(currency.id)}
						/>
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	renderPagination = () => {
		let meta = this.state.data.currencies.resource
		let last_page = meta.last_page
		let current_page = meta.current_page - 1
		let pagination = null

		last_page > 1 ?
			pagination = <ReactPaginate
				previousLabel={<Icon>navigate_before</Icon>}
				nextLabel={<Icon color="primary">navigate_next</Icon>}
				breakLabel={<a href="">...</a>}
				breakClassName={"break-me"}
				pageCount={last_page}
				initialPage={current_page}
				disableInitialCallback= {true}
				marginPagesDisplayed={2}
				pageRangeDisplayed={5}
				onPageChange={this.handlePageChange}
				containerClassName={"pagination"}
				subContainerClassName={"pages pagination"}
				activeClassName={"active"}
			/>
		: null

		return pagination
	}

	componentWillMount() {
		this.props.initCurrencies().then(res => {
			this.getDefaultCurrency()
			this.setState({'data' : this.props.currencies})
		})
	}

	classes = this.props.classes

	render() {
		const {data, currency} = this.state
		let isFetching = data ? data.isFetching : true

		return(
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress
						className={this.classes.progress}
						size={50}
					/>
				</div>
			:
				<div>
					<div className={this.classes.formWrap}>
						<FormControl className={this.classes.formControl}>
							<InputLabel>Default currency</InputLabel>
							<Select
								value={currency}
								onChange={this.hadleCurrencyChange}
								inputProps={{
									'name' : 'currency'
								}}>
								{this.renderCurrenciesSelectList()}
							</Select>
						</FormControl>
						<TextField
							className={this.classes.textField}
							label="Family price"
							name="family_price"
							value={data.family_price}
							onInput={this.handleDataChange}
						/>
						<TextField
							className={this.classes.textField}
							label="School price"
							name="school_price"
							value={data.school_price}
							onInput={this.handleDataChange}
						/>
						<Button
							className={this.classes.button}
							variant="raised"
							color="primary"
							onClick={this.onSubmit}>
							Ok
						</Button>
					</div>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell padding="none">
									CODE
								</TableCell>
								<TableCell padding="none">
									COEFFICIENT
								</TableCell>
								<TableCell padding="none">
									STATUS
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{this.renderCurrenciesList()}
						</TableBody>
					</Table>
					{this.renderPagination()}
				</div>
		)
	}
}

Currency = connect(
	state => ({
		currencies: state.currencies
	}),
	dispatch => ({
		bridge          : data => dispatch(data),
		initCurrencies 	: data => dispatch(currenciesAction()),
		pageChange 		: page => dispatch(currenciesAction(page))
	})
)(Currency);

export default withStyles(styles)(Currency);



// WEBPACK FOOTER //
// ./src/components/content/Currency.js